var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoTrainKorailH16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 16,
  viewBox: "0 0 56 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "7n2hp6rjma1",
  cx: "12.514%",
  cy: "40.386%",
  r: "85.168%",
  fx: "12.514%",
  fy: "40.386%",
  gradientTransform: "matrix(.36535 0 0 1 .08 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00A2D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "29.363%",
  stopColor: "#00A2D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#005BAB"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "5aad775kvb2",
  cx: "19.379%",
  cy: "-11.394%",
  r: "128.184%",
  fx: "19.379%",
  fy: "-11.394%",
  gradientTransform: "matrix(.46726 0 0 1 .103 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00A2D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "27.964%",
  stopColor: "#00A2D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#005BAB"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005BAB",
  d: "M45.033 3.618c-.56 0-.79.2-.909.717l-1.34 8.295h3.013l1.462-9.012zm-34.402-.251H8.023c-.4 0-.627.128-.896.376l-2.978 2.9.72-3.276H2.506c-.562 0-.795.2-.907.722L0 12.63h2.964l.813-4.02 2.762 4.02h3.689L6.555 7.4l4.076-4.032zM50.96 10.52l1.188-6.902h-2.227c-.55 0-.784.193-.9.688l-1.346 8.324h7.105l.273-2.11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#7n2hp6rjma1)",
  d: "M16.164.025a6.71 6.71 0 0 0-6.013 5.357c1.625-1.455 4.74-1.97 9.512-.34a34 34 0 0 1 2.96 1.168c.823.37 1.659.806 2.531 1.31 1.797 1.034 3.804 2.472 5.429 4.21h4.397l3.004-6.116.017-.202 1.18 6.32h3.082l-1.894-9.014h-2.846c-.446 0-.633.128-.831.444l-3.71 7.344-2.645-2.392c1.196-.333 2.528-1.253 2.902-2.796.663-2.739-1.65-2.851-2.418-2.851h-4.247c-.549 0-.648.117-.763.617l-.815 3.839c-2.082-1.355-6.811-4.106-10.135-4.152-.84-.01-1.45.118-2.044.482-.087.055-.109.051-.124.048l.047-.098c.358-.439 1.091-1.14 2.32-1.522 0 0 1.967-.687 4.598.914a28 28 0 0 1 3.567 2.54C22.507 2.166 19.855 0 16.742 0q-.287 0-.578.025m12.529 3.871h1.102s1.101-.066.709 1.422c0 0-.437 1.76-2.468 1.76.09-.453.59-2.86.657-3.182",
  transform: "translate(0 .9)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#5aad775kvb2)",
  d: "M12.593 6.243s-1.539.707-1.636 2.454c-.103 1.697 1.19 2.873 1.19 2.873l.007.01a6.7 6.7 0 0 0 4.55 1.794h.049q.28-.001.565-.025c3.04-.26 5.39-2.53 5.958-5.368.225.055.71.193 1.402.421l-.706 3.328h3.11s.251-1.31.492-2.347c-1.766-1.069-3.644-1.808-3.644-1.808-3.336-1.428-6.09-1.968-8.149-1.968-1.393 0-2.468.248-3.188.636",
  transform: "translate(0 .9)"
}))));
export default SvgLogoTrainKorailH16;